import type { Plan } from './plan.type.ts';
export interface PlanExtension extends Plan {}
export class PlanExtension {
  // ── Computed Properties ──
  get isWellness() {
    return this.cadence === 'NEVER';
  }
}

const Registration = {
  kind: 'object',
  name: 'plan',
  features: PlanExtension,
};
export default Registration;
